export default __webpack_public_path__ + "static/media/Verfied Pre-sale.15ec3d37.png";